import {
    css, Theme,
} from '@emotion/react'

import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        container: (props: { active?: boolean }) => {
            return css`
                ${custom.boxShadowRadius};
                ${custom.border};
                overflow: hidden;
                cursor: ${!props || props.active ? 'pointer' : 'default'};
            `
        },
        topWrapper: (props: { disabled?: boolean }) => {
            return css`
                height: 134px;
                background: ${!props || props.disabled
        ? theme.palette.secondary[200]
        : theme.palette.primary[100]};
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px 0px;
            `
        },
        bottomWrapper: (props: { disabled?: boolean }) => {
            return css`
                height: 89px;
                padding: 20px;
                box-sizing: border-box;
                opacity: ${!props || props.disabled ? 0.5 : 1};
            `
        },
        icon: css`
            width: 59px;
            height: 59px;
            padding-left: 20px;
            padding-top: 39px;
            padding-bottom: 36px;
         `,
    }
}

export default styles
